import React from 'react';

export default function SiteImages({ images, handleSelectedImage }) {

  const defaultImages = images.slice(0, 3)
  const moreImages = images.slice(3)

  const showDefaultImages = defaultImages?.map(image =>
    <div className="col-4" key={image}>
      <div type="button" data-toggle="modal" data-target={`#${image.replace(/[^a-z]/g, '')}`} onClick={handleSelectedImage} >
        <img src={image} alt="site image" className="img img-fluid" />
      </div>
    </div>
  )

  const showMoreImages = moreImages?.map(image =>
    <div className="col-4 mb-3" key={image}>
      <div type="button" data-toggle="modal" data-target={`#${image.replace(/[^a-z]/g, '')}`} onClick={handleSelectedImage} >
        <img src={image} alt="site image" className="img img-fluid" />
      </div>
    </div >
  )

  return (
    <div>
      <p className="text-left font-weight-bold mt-5">Site images</p>
      <div className="row">
        {showDefaultImages}
      </div>
      {moreImages.length && (<div className="mt-4">
          <div data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
            <p className="text-center">See all images<i className="fas fa-chevron-down ml-2"></i></p>
          </div>
          <div className="collapse" id="collapseExample">
            <div className="row">
              {showMoreImages}
            </div>
          </div>
        </div>)}
    </div>
  )
}
